import UserMenu from '../UserMenu/UserMenu';
import Icon from '../../ui/Icon/Icon';
import styles from './Navbar.module.css';

// Slim top bar. Left: hamburger (mobile) + terminal-style status. Right: user menu.
export default function Navbar({ onMenuOpen }) {
  return (
    <header className={styles.navbar}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <button
            type="button"
            className={styles.menuBtn}
            onClick={onMenuOpen}
            aria-label="Open navigation menu"
          >
            <Icon name="Menu" size={20} />
          </button>
          <div className={styles.status}>
            <span className={styles.statusDot} aria-hidden="true" />
            <span>SYS / ONLINE</span>
            <span className={styles.path}>
              &nbsp;&middot;&nbsp;<strong>~/sabia</strong>
            </span>
          </div>
        </div>
        <nav className={styles.actions}>
          <UserMenu />
        </nav>
      </div>
    </header>
  );
}
